import gql from 'graphql-tag'

export const IMPORT_PAGE = gql`
    mutation importPage($input: ImportDataInput!) {
        importPage(input: $input) {
            success
            message
            block {
                id
                identifier
                createdAt
                deletedAt
                currentVersion {
                    id
                    name
                    state
                    contents
                    updatedBy {
                        id
                        name
                    }
                    createdAt
                    updatedAt
                }
            }
            page {
                id
                parentPageIdentifier
                sortIndex
                deactivated
                isTemplate
                isStartPage
                createdAt
                updatedAt
                currentVersion {
                    id
                    pageID
                    state
                    contents
                    createdAt
                    updatedAt
                    updatedBy {
                        id
                        name
                    }
                    pageSettings {
                        htmlTitle
                        urlTitle
                        metaDescription
                        metaKeywords
                        robotsOption
                        includeInSitemapXML
                        pageRank
                        changeFrequency
                        language
                        translationID
                    }
                }
            }
        }
    }
`
